import { authenticateUser, fetchSubscriptionDetails } from "@/Redux/Actions";
import { RootState } from "@/Redux/Reducers";
import { getAuthToken } from "@/Utils/authToken";
import { useCountdownHook } from "@/Utils/countdownTimerHook";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

export function useAuthAndSubscription({ preventAPICall }) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const { storeData } = useSelector((state: RootState) => ({
    storeData: state.storeReducer.store,
  }));
  const [timeDifference] = useCountdownHook(storeData?.theme?.expiry);

  // effect to update store details once time ends
  useEffect(() => {
    if (preventAPICall) {
      return;
    }

    if (timeDifference && timeDifference < 0 && getAuthToken()) {
      dispatch(authenticateUser(getAuthToken(), history));
    }
  }, [timeDifference, preventAPICall]);

  useEffect(() => {
    if (preventAPICall) {
      return;
    }

    if (getAuthToken()) {
      dispatch(authenticateUser(getAuthToken(), history));
      dispatch(fetchSubscriptionDetails());
    }
  }, [location.pathname, preventAPICall]);

  return null;
}
